var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Pagination } from 'packages/core/Pagination';
import { Entity, Type } from '@decahedron/entity';
import { JsonExclude } from '@decahedron/entity/dist/src/support/JsonExclude';
var PaginatedQuery = /** @class */ (function (_super) {
    __extends(PaginatedQuery, _super);
    function PaginatedQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filters = null;
        _this.pagination = null;
        return _this;
    }
    PaginatedQuery.prototype.toJson = function (toSnake, asString) {
        var _a;
        var json = _super.prototype.toJson.call(this, toSnake, asString);
        var newJson = __assign({}, json);
        if ((_a = this.filters) === null || _a === void 0 ? void 0 : _a.toJson) {
            var filterObjects = this.filters.toJson();
            newJson = __assign(__assign({}, newJson), filterObjects);
        }
        if (this.pagination) {
            var flattenedPagination = this.pagination.toJson();
            newJson = __assign(__assign({}, newJson), flattenedPagination);
        }
        Object.keys(newJson).forEach(function (key) {
            if (newJson[key] === null) {
                delete newJson[key];
            }
        });
        return asString ? JSON.stringify(newJson) : newJson;
    };
    var _a;
    __decorate([
        Type(Object),
        JsonExclude(),
        __metadata("design:type", Boolean)
    ], PaginatedQuery.prototype, "filters", void 0);
    __decorate([
        Type(Pagination),
        JsonExclude(),
        __metadata("design:type", typeof (_a = typeof Pagination !== "undefined" && Pagination) === "function" ? _a : Object)
    ], PaginatedQuery.prototype, "pagination", void 0);
    return PaginatedQuery;
}(Entity));
export { PaginatedQuery };
